import { render } from "./TabsParentSubject.vue?vue&type=template&id=a2485d72&ts=true"
import script from "./TabsParentSubject.ts?vue&type=script&lang=ts"
export * from "./TabsParentSubject.ts?vue&type=script&lang=ts"

import "./TabsParentSubject.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__